/**
 * Subscribe Horizon motion sources to ADA_GlobalPause:
 * slideshows, announcement bar, marquees, autoplay videos.
 */
(function () {
  'use strict';

  function pauseAll() {
    document.querySelectorAll('slideshow-component').forEach(function (el) {
      if (typeof el.pause === 'function') el.pause();
      else if (typeof el.pauseSlideshow === 'function') el.pauseSlideshow();
      el.setAttribute('data-ak-paused', 'true');
    });

    document.querySelectorAll('announcement-bar-component').forEach(function (el) {
      if (typeof el.pause === 'function') el.pause();
      el.setAttribute('data-ak-paused', 'true');
    });

    document.querySelectorAll('marquee-component').forEach(function (el) {
      if (typeof el.togglePause === 'function') {
        if (!el.hasAttribute('data-disabled')) {
          el.togglePause();
        }
        el.setAttribute('data-ak-paused', 'true');
      }
    });

    document.querySelectorAll('video[autoplay], video[data-autoplay], .video_autoloop_wrapper video').forEach(function (video) {
      try {
        video.pause();
      } catch (e) {
        /* ignore */
      }
    });
  }

  function resumeAll() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('slideshow-component[data-ak-paused]').forEach(function (el) {
      el.removeAttribute('data-ak-paused');
      if (typeof el.play === 'function') el.play();
      else if (typeof el.playSlideshow === 'function') el.playSlideshow();
    });

    document.querySelectorAll('announcement-bar-component[data-ak-paused]').forEach(function (el) {
      el.removeAttribute('data-ak-paused');
      if (typeof el.play === 'function') el.play();
    });

    document.querySelectorAll('marquee-component[data-ak-paused]').forEach(function (el) {
      el.removeAttribute('data-ak-paused');
      if (typeof el.togglePause === 'function' && el.hasAttribute('data-disabled')) {
        el.togglePause();
      }
    });
  }

  function bind() {
    if (!window.ADA_GlobalPause || typeof window.ADA_GlobalPause.registerCustom !== 'function') return;
    window.ADA_GlobalPause.registerCustom({ pause: pauseAll, resume: resumeAll });
  }

  document.addEventListener('ada-global-pause:ready', bind);
  if (window.ADA_GlobalPause) bind();
})();
